
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Aarti Anantbhuja" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Aarti Anantbhuja" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Aarti Anantbhuja, Anantbhuja Aarti lyrics, Lord Anantbhuja Aarti, aarti anant bhuja lyrics in english, aarti anant bhuja lyrics in marathi, पांडुरंगाची आरती'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Aarti Anantbhuja, Anantbhuja Aarti lyrics, Lord Anantbhuja Aarti, Devotional Aarti, Marathi Aarti, Anantbhuja Bhakti Geet, Aarti for Anantbhuja, Aarti collection, devotional aarti, Aarti lyrics in Marathi, aarti anant bhuja lyrics, aarti anant bhuja lyrics in english, aarti anant bhuja lyrics in marathi, पांडुरंगाची आरती - आरती अनंतभुजा, आरती अनंतभुजा, श्री पंढरीराजाची आरती'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/pandhariraja.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/pandhariraja.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Aarti Anantbhuja | Pandharirajachi Aarti - आरती अनंतभूजा (पंढरीराजाची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/pandhariraja"
        },
        "headline": "Aarti Anantbhuja - आरती अनंतभूजा (पंढरीराजाची आरती)",
        "name" : "Aarti Anantbhuja - Pandharirajachi Aarti",
        "description": "Explore the full lyrics of Aarti 'Aarti Anantbhuja' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/pandhariraja.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  